// extracted by mini-css-extract-plugin
module.exports = {"container":"_a4604a4"};